import BaseTabs, {
  TabPaneProps as BaseTabPaneProps,
  TabsProps as BaseTabsProps,
} from 'antd/lib/tabs'

export interface TabProps extends BaseTabsProps {}

export const Tabs = (props: TabProps): JSX.Element => (
  <>
    <BaseTabs {...props} />
  </>
)

export interface TabPaneProps extends BaseTabPaneProps {}

export const TabPane = (props: TabPaneProps): JSX.Element => (
  <>
    <BaseTabs.TabPane {...props} />
  </>
)
